export default require.context('!svg-url-loader!@/assets/icons/', true, /^\.\/.*\.svg$/);
